import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import ChecklistForm from 'pages/app/checklists/ChecklistForm'

export default function TabletChecklist () {
  return (
    <AdminPage>
      <ChecklistForm/>
    </AdminPage>
  )
}
